import { join } from 'light-component';
import { useState, type ReactElement } from 'react';
import { Rate } from 'antd';
import { Box } from '../../../box';
import styles from '../style.module.less';
import { Highlighter } from '../../component';
import { Character } from './character';
import type { ShotEyesStarProps } from './types';

export function ShotEyesStarViewMode(props: ShotEyesStarProps): ReactElement {
  const [value] = useState<number>(props.value ?? 0);

  return (
    <Box className={styles.viewBox}>
      <Box className={join(styles.subject, styles.input)}>
        <Highlighter
          title={props.title}
          keyword={props.keyword}
          className={styles.title}
        />
      </Box>
      <Box className={join(styles.content, styles.inputContent)}>
        <Rate
          className={styles.rate}
          disabled
          value={props.value}
          count={props.option?.length ?? 5}
          character={rate => (
            <Character
              index={rate.index}
              selectStyle={props.selectStyle}
              option={props.option}
              value={value}
            />
          )}
        />
      </Box>
    </Box>
  );
}
